<template lang="html">
  <button class="wcc button" type="button" :class="[colorClass, {invalid: invalid, active: active}]">
    <template v-if="submitting">
      <font-awesome-icon :icon="['fa', 'spinner']" :pulse="true"></font-awesome-icon>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </button>
</template>
<script>
  export default {
    props: [
      'value',
      'submitting',
      'invalid',
      'color',
      'active'
    ],
    computed: {
      colorClass() {
        if (this.color == 'white') {
          return ['white']
        }
        return []
      }
    }
  }
</script>
<style lang="scss">
</style>